import { apiCall } from "../../../../utils/apiCall";

export const fetchSalesContestData = async (token: string, projectKey: string) => {
	const header = {
		headers: {
			Authorization: `Bearer ${token}`,
			"X-Project-Id": "AF",
			"X-Authorization-Provider": "Anonymous",
			"X-Project-Key": projectKey,
		}
	};
	try {
		const data = await apiCall({
			method: "GET",
			header: header,
			endPoint: process.env.REACT_APP_GET_SALES_CONTEST_LIST,
		});
		console.log("data", data);
		return data;
	} catch (error) {
		console.log(error);
		throw error;
	}
};
